export default {
  "content": "<path d=\"M21.226 9.007a5.074 5.074 0 00-4.497-2.69H2.486a.49.49 0 00-.343.837l3.102 3.12a1.461 1.461 0 001.035.43h10.04a1.295 1.295 0 01.027 2.59H9.425a.49.49 0 00-.346.836l3.104 3.123a1.46 1.46 0 001.035.43h3.13c4.074 0 7.154-4.355 4.878-8.678\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};